export const appConfig = {
  format: {
    date: 'MM/DD/YYYY',
    isoDateTime: 'YYYY-MM-DDTHH:mm:ss',
    shortDate: 'MM/DD',
  },
  apiHost: process.env.REACT_APP_API_HOST,
  appUrl: 'https://www.internationalsurrogacycenter.com',
};
